import {
  Anytime,
  Effortless,
  Facebook,
  FeaturesBgAr,
  Instagram,
  Realtime,
  Scalable,
  Search,
  Secure,
  Snapchat,
  Twitter,
} from "../Styled/AllImages";
import {
  Cabinets,
  Dashboard,
  FeaturesBg,
  History,
  HQBranches,
  Phone,
  Requests,
  Settings,
  Users,
} from "../Styled/AllImages";
import { Box, Span, SpanStyled } from "../Styled/Elements";

export const NavDataConfig = [
  {
    to: "home",
    label: "Home",
  },
  {
    to: "features",
    label: "Features",
  },
  // {
  //   to: "pricing",
  //   label: "Pricing",
  // },
  {
    to: "faqs",
    label: "FAQs",
  },
  {
    to: "contact",
    label: "Contact",
  },
];
export const PageNavConfig = [
  {
    to: "/",
    label: "Home",
    link: false,
  },
  {
    to: "features",
    label: "Features",
    link: false,
  },
  // {
  //   to: "pricing",
  //   label: "Pricing",
  //   link: false,
  // },

  {
    to: "faqs",
    label: "FAQs",
    link: false,
  },
  {
    to: "contact",
    label: "Contact",
    link: false,
  },
];
export const footerNavs = [
  {
    to: "home",
    label: "Home",
    link: false,
  },
  {
    to: "features",
    label: "Features",
    link: false,
  },
  // {
  //   to: "pricing",
  //   label: "Pricing",
  //   link: false,
  // },

  {
    to: "faqs",
    label: "FAQs",
    link: false,
  },
  {
    to: "contact",
    label: "Contact",
    link: false,
  },
  {
    to: "tutorials",
    label: "tutorial_videos",
    link: true,
  },
  {
    to: "who-we-are",
    label: "WhoWeAre",
    link: true,
  },
  {
    to: "term-conditions",
    label: "terms_condition",
    link: true,
  },
  {
    to: "privacy-policy",
    label: "privacy_policy",
    link: true,
  },
];

export const socialIcon = [
  {
    img: <Facebook />,
    link: "#!",
  },

  {
    img: <Twitter />,
    link: "#!",
  },
  {
    img: <Instagram />,
    link: "#!",
  },
  {
    img: <Snapchat />,
    link: "#!",
  },
];

export const features = [
  {
    name: "secure_storage",
    desc: "data_is_encrypted_stored",
    icon: Secure,
  },
  {
    name: "anytime_anywhere_success",
    desc: "access_doc_anywhere",
    icon: Anytime,
  },
  {
    name: "scalable_solutions",
    desc: "easily_scale_your_storage",
    icon: Scalable,
  },
  {
    name: "effortless_organization",
    desc: "categorize_and_manage_file",
    icon: Effortless,
  },
  {
    name: "realtime_collaboration",
    desc: "work_together_seamlessly",
    icon: Realtime,
  },
  {
    name: "advance_search",
    desc: "quickly_find_what_you_need",
    icon: Search,
  },
];
export const modules = [
  {
    name: "dashboard",
    icon: <Dashboard />,
    previewImage: FeaturesBg,
  },
  {
    name: "cabinets",
    icon: <Cabinets />,
    previewImage: FeaturesBg,
  },
  {
    name: "requests",
    icon: <Requests />,
    previewImage: FeaturesBg,
  },
  {
    name: "history",
    icon: <History />,
    previewImage: FeaturesBg,
  },
  {
    name: "users",
    icon: <Users />,
    previewImage: FeaturesBg,
  },
  {
    name: "hq_branches",
    icon: <HQBranches />,
    previewImage: FeaturesBg,
  },
  {
    name: "settings",
    icon: <Settings />,
    previewImage: FeaturesBg,
  },
  {
    name: "support",
    icon: <Phone />,
    previewImage: FeaturesBg,
  },
];
export const modulesAr = [
  {
    name: "dashboard",
    icon: <Dashboard />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "cabinets",
    icon: <Cabinets />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "requests",
    icon: <Requests />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "history",
    icon: <History />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "users",
    icon: <Users />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "hq_branches",
    icon: <HQBranches />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "settings",
    icon: <Settings />,
    previewImage: FeaturesBgAr,
  },
  {
    name: "support",
    icon: <Phone />,
    previewImage: FeaturesBgAr,
  },
];
export const pricingPlans = [
  {
    id: 1,
    plan_name: "basic_plan_free",
    desc: "quickest_way_to_try_cloud_archive",
    price: 0,
    btn_text: "get_started",
    color: "var(--themeColor2)",
    stroke: "var(--themeColor2)",
    bg: "--white",
    border: "#eaedf3",
    isBorder: false,
    isCustom: false,
    isBasic: true,
    access_features: [
      "five_archives_allowed",
      "basic_support",
      "access_from_any_device",
    ],
  },
  {
    id: 2,
    plan_name: "professional_plan",
    desc: "enhanced_doc_management",
    price: 300,
    btn_text: "get_started",
    color: "var(--white)",
    stroke: "var(--themeColor)",
    bg: "--themeColor",
    border: "var(--themeColor)",
    isBorder: true,
    isCustom: false,
    isBasic: false,
    access_features: [
      "unlimited_archives",
      "priority_support",
      "access_from_any_device",
    ],
  },
  {
    id: 3,
    plan_name: "custom_enterprise_plan",
    desc: "custom_solutions_for_comprehensive_doc_management",
    price: 0,
    btn_text: "contact_sales_team",
    color: "var(--themeColor2)",
    stroke: "var(--themeColor2)",
    bg: "--white",
    border: "#eaedf3",
    isBorder: false,
    isCustom: true,
    isBasic: false,
    access_features: [
      "unlimited_archives",
      "tailored_features_integration",
      "dedicated_account_manager",
      "contact_sales_team_for_customized",
    ],
  },
];

export const faqData = [
  {
    id: 5,
    question: "faqs_question_five",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_five")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five", "six"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">
                    {t(`faqs_answer_five_bullet_${num}`)}
                  </Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_five_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_five_below")}</SpanStyled>
      </>
    ),
  },
  {
    id: 6,
    question: "faqs_question_six",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_six")}</SpanStyled>
        <SpanStyled>{t("faqs_answer_six_top")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five", "six"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">
                    {t(`faqs_answer_six_bullet_${num}`)}
                  </Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_six_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_six_below")}</SpanStyled>
      </>
    ),
  },
  {
    id: 1,
    question: "faqs_question_one",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_one")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five", "six"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">{t(`faqs_answer_one_bullet_${num}`)}</Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
  {
    id: 2,
    question: "faqs_question_two",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_two")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five", "six"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">{t(`faqs_answer_two_bullet_${num}`)}</Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_two_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
  {
    id: 3,
    question: "faqs_question_three",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_three")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">
                    {t(`faqs_answer_three_bullet_${num}`)}
                  </Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_three_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
  {
    id: 4,
    question: "faqs_question_four",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_four")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four", "five", "six"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="600">
                    {t(`faqs_answer_four_bullet_${num}`)}
                  </Span>
                  &nbsp;
                  <SpanStyled>
                    {t(`faqs_answer_four_bullet_${num}_description`)}
                  </SpanStyled>
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
];

export const durationOptions = [
  { id: 1, label: "monthly" },
  // { id: 2, label: "quarterly" },
  // { id: 3, label: "semi_annually" },
  { id: 4, label: "annually" },
];
